import "./App.css";
import CourseFooter from "./components/Footer";
import Header from "./components/Header";
import MiddleBar from "./components/MiddleBar";
import SlickSlider from "./components/Slider";
import TopBar from "./components/TopBar";
import Course from "./pages/course/Course";
import InquiryForm from "./pages/enquiry/Enquiry";

function App() {
  return (
    <div className="">
      <TopBar />
      <MiddleBar />
      <Header />
      <SlickSlider />
      <Course />

        {/* <InquiryForm /> */}
        <CourseFooter/>
     
    </div>
  );
}

export default App;
